import { render, staticRenderFns } from "./NotificationWorkflowIcon.vue?vue&type=template&id=3ed89640&"
import script from "./NotificationWorkflowIcon.vue?vue&type=script&lang=ts&"
export * from "./NotificationWorkflowIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports